import { useEffect, useRef } from 'react'
import type { TrackSnapshot } from '@/entities/call'
import { Avatar } from '@/shared/ui/avatar'

interface CameraPreviewProps {
  track: TrackSnapshot | null
  name: string
}

export function CameraPreview({ track, name }: CameraPreviewProps) {
  const ref = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    const el = ref.current
    if (!el || !track) return
    track.attach(el)
    return () => track.detach(el)
  }, [track])

  return (
    <div className="relative aspect-video overflow-hidden rounded-card border border-border-default bg-bg-sunken">
      {track ? (
        /* Превью всегда локальная камера — зеркалим отображение (поток не трогаем).
           object-contain: кадр целиком, без кропа — как он придёт в звонок. */
        <video
          ref={ref}
          autoPlay
          playsInline
          muted
          className="h-full w-full -scale-x-100 object-contain"
        />
      ) : (
        <div className="flex h-full w-full items-center justify-center">
          <Avatar name={name} size="lg" />
        </div>
      )}
    </div>
  )
}
